import { render } from "./opay.vue?vue&type=template&id=04560f6c&scoped=true"
const script = {}

import "./opay.vue?vue&type=style&index=0&id=04560f6c&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04560f6c"]])

export default __exports__